import Axios from "axios";
import { API_URL } from "../config";

export class DashboardService {
  static loadDashboard = async () => await Axios.get(`${API_URL}/dashboard`);
  static loadClientDashboard = async () => await Axios.get(`${API_URL}/client_admin/dashboard`);
}
